import './App.css';
import { BrowserRouter } from "react-router-dom"
import Routers from './Routes';
import ScrollToTop from './GuestPages.js/ScrollToTop';




function App() {

  return (
   
     <>
    
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routers />
      </BrowserRouter>
      
    </div>
  
    </>
  );
}

export default App;
